import { toast } from "react-toastify";

export function postNotification(toastType, toastMessage, ignoreBugsnag) {
  var message =
    typeof toastMessage === "object"
      ? toastMessage.response?.data?.errorMessage ||
        toastMessage.response?.data?.error ||
        toastMessage.response?.data ||
        toastMessage.message ||
        toastMessage
      : toastMessage;
  if (toastType === "info") {
    toast.info(message);
  } else if (toastType === "success") {
    toast.success(message);
  } else if (toastType === "warning") {
    toast.warning(message);
  } else if (toastType === "error") {
    toast.error(message);
  } else if (toastType === "dark") {
    toast.dark(message);
  } else {
    toast(message);
  }
}
